export const FORM_PLACEHOLDER = {
  DATE: '00/00/0000',
  AMOUNT: '$0.00',
  PHONE: '(305) 555-1234',
} as const
